window.originalArrayFind = Array.prototype.find;		
Array.prototype.find = originalArrayFind;
window.dialogImageError=function(el){
	var srcvalue=el.getAttribute('src');
	var frame=$(el).parent().find('iframe');
	var img=$(el);
	img.attr('style','display:none;');
	frame.attr('style','display:block;width:100%;margin-top:60px;height:'+(window.innerHeight-70-60)+'px;');
	frame.attr('src',srcvalue);
}
window._forceModal=null;
window.forceModal=function(img,frm,txt,after){
	var html=[];
	html.push('<div class="diamond-search"><div class="modal fade visible">');
	html.push('<div class="modal-dialog"><div class="modal-content">');
	
	if (typeof(txt)!='undefined' && txt!=null){
		html.push('<div class="modal-body">');
		html.push(txt);
	} else {
		html.push('<div class="modal-body" style="text-align:center;">');
		if (frm!=null){
			html.push('<iframe style="display:none;width:100%;margin-top:60px;height:'+(window.innerHeight-70-60)+'px;" src="'+frm.replace('http:','').replace('https:','')+'"></iframe>');
		} else {
			html.push('<img class="col-xs-12" style="margin-top:60px;max-height:'+(window.innerHeight-70-60)+'px;" shouldhaveproxied="true" src="'+img.replace('http:','').replace('https:','')+'" onerror="window.dialogImageError(this);"><iframe style="display:none;width:100%;margin-top:60px;height:'+(window.innerHeight-70-60)+'px;"></iframe>');
		}
	}
	html.push('</div>');
	html.push('<div class="modal-footer"><button class="btn btn-default btn-close" type="button">x</button></div>');
	html.push('</div></div>');
	html.push('</div></div>');
	if (window._forceModal!=null) window._forceModal.remove();
	window._forceModal=$(html.join(''));
	var after=after;
	if (typeof(after)=='undefined'||after==null) after=function(){};
	var target=this;
	$(window._forceModal).find('.btn-close').on('click',function(){$(this).closest('.diamond-search').remove();after(target);});
	$('body').prepend(window._forceModal);
    $( function() {$( ".docs-date" ).removeClass('hasDatepicker'); $( ".docs-date" ).datepicker();} );
}
window.jsonpcallback=function(d){
//$('.diamond-search .modal .request-schedule').addClass('hide');
//$('.diamond-search .modal .request-response').addClass('hide');		
//$('.diamond-search .modal .request-buttons').removeClass('hide');
}
window.SendRequest=function(action,t){
	jQuery('.diamond-search .modal .request-buttons').addClass('hide');
	jQuery('.diamond-search .modal .request-response').removeClass('hide');
	var s={'action':action};
	var found=jQuery(t).closest('.request-form').find('input,select');
	for(var i=0;i<found.length;i++){ s[$(found[i]).attr('name')]=$(found[i]).val();}
	s.submitted=1;
	$.ajax({url:'https://www.since1910.com/certificate.aspx?certificate=email&host=hlgross',jsonp:'jsonpcallback',type:'POST',dataType:'jsonp',data:s,success:function(data){
	//$('.diamond-search .modal .request-schedule').addClass('hide');
	//$('.diamond-search .modal .request-response').addClass('hide');		
	//$('.diamond-search .modal .request-buttons').removeClass('hide');
	}});
    window.setTimeout(function(){window.jsonpcallback();},1000);
}

angular.module('ngClick', function( $location ) { 
	return { 
		link: function(scope, elem, attrs) { 
			if(attrs.href) { elem.on('click,touchend', function() { 
				$location.path(attrs.href); 
			}); 
		} 
	}, 
	priority: 1 
	}; 
});   


      var s10app=angular.module('sntapp',[]);
s10app.filter('encodeURIComponent', function() {
    return window.encodeURIComponent;
});

s10app.filter('nohttp', function() {
    return function(input){
		if (typeof(input)!='undefined'&&input!=null) return input.replace('http:','').replace('https:','');
		return null;
    };
});
		s10app.filter('reverse', function() {
		  return function(items) {
			return items.slice().reverse();
		  };
		});	  

      s10app.factory('Diamonds',function(){
        var data={data:[],keys:[]};
        for(var k in since1910.ui.resources.diamonds){
          data.keys.push(k);
        }
        data.data=since1910.ui.resources.diamonds;
        return data;
      });


      s10app.controller('sntctrl',SNTController);

function SNTController($scope,Diamonds,$http){
        $scope.diamonds = Diamonds;
        $scope.onHover=function($event,item){
          if ($scope.selected!=null){
            var s=$scope.selected.target.attributes['class'].value.split(' ');
            if (s.indexOf('hover')>=0) {
              s.splice(s.indexOf('hover'),1);
              $scope.selected.target.attributes['class'].value=s.join(' ');
            }
          }
          $scope.selected={item:item,target:$event.currentTarget};
          var s=$scope.selected.target.attributes['class'].value.split(' ');
          if (s.indexOf('hover')<=0) {
            s.push('hover');
            $scope.selected.target.attributes['class'].value=s.join(' ');
          }    
		  
		  	
        };
        $scope.selected=null;
		$scope.loading=true;
        $scope.modal=null;
        $scope.modalframe=null;
        $scope.modalimg=null;
        $scope.modalimgstyle=null;
        $scope.modalframestyle=null;
        $scope.viewmodal=null;
        $scope.results=[];
		$scope.placeholder=null;
		$scope.retained={"length":0,"index":0,"sort":"bprice asc","data":[]};
		$scope.viewRetained=false;
		if (typeof(Storage) !== "undefined") {
			if(typeof(localStorage.diamonds)!='undefined'){
				try {
					$scope.retained=JSON.parse(localStorage.diamonds);
				} catch(ex){
					$scope.retained={"length":0,"index":0,"sort":"bprice asc","data":[]};					
					localStorage.diamonds=JSON.stringify($scope.retained);
				}
			}
		} else {
			$scope.retained=null;
		}
        $scope.retain=function(d){
			if ($scope.retained!=null) {
				var clone={};for(var n in d.item){if(n[0]!='$'&&n!='parent') clone[n]=d.item[n];};				
				var indexOf=-1;
				for(var i=$scope.retained.data.length;i>0;i--) {
					if ($scope.retained.data[i-1].id==clone.id) {$scope.retained.data.splice(i-1,1);}
				}
				$scope.retained.data.push(clone);
				if ($scope.retained.data.length>50) $scope.retained.shift(1);
				$scope.retained.length=$scope.retained.data.length;
				localStorage.diamonds=JSON.stringify($scope.retained);
			}
        },
		$scope.toggleRetained=function(){
			if($scope.viewRetained) $scope.offRetained();
			else $scope.onRetained();
		},
		$scope.onRetained=function(){
			$scope.viewRetained=true;
			$scope.placeholder=$scope.results;
			$scope.results=JSON.parse(JSON.stringify($scope.retained));
			$scope.filter.handleChange(true);
		},
		$scope.offRetained=function(){
			$scope.viewRetained=false;
			$scope.results=$scope.placeholder;
			$scope.placeholder=null;
			$scope.filter.handleChange(true);
		},
        $scope.onModal=function(item,$event){
          $scope.viewmodal=null;
          $scope.modal=item;
          $scope.modalframe=null;    
		  window.forceModal(item.il,null);
        },
        $scope.onForceModal=function(item,$event){
		  window.forceModal(item.il,null);
        },		
        $scope.onCert=function(item,$event){
          $scope.modal={il:'https://www.since1910.com/certificate.aspx?certificate=html&key='+item.lnk};
          $scope.modalframe=null;    
		  window.forceModal($scope.modal.il);
        },
        $scope.offModal=function(){
			
			var frame=$('.diamonds .modal-body iframe');
			var img=frame.parent().find('img');
			frame.attr('style','display:none;');
			frame.attr('src',null);
			img.attr('src',null);
			img.attr('style','display:block;');
			
          $scope.viewmodal=null;
          $scope.modalimg=null;
          $scope.modalframe=null;
          $scope.modal=null;    
        },    
        $scope.filter={
          shape:$scope.diamonds.data.round,
          color:[],cut:[],clarity:[],sku:null,polish:[],symmetry:[],fluorescence:[],
          weight:$scope.diamonds.data.round.weight,
		  table:$scope.diamonds.data.round.table,
		  depth:$scope.diamonds.data.round.depth,
          price:$scope.diamonds.data.round.price,
          page:function(index,$event){
            $scope.filter.navigation.page=index;
            $scope.filter.change();
          },    
		  advanced:false,
          navigation:{index:0,start:0,end:0,size:50,length:0,sort:'bprice asc',sorting:{column:'bprice',direction:'asc'},pages:[],
            init:function () {
                if (this.length==0) {
                  return {};
                }
                //records, recordsperpage, display, current, base
                var records=this.length;
                var recordsperpage=this.size;
              
                var current=this.page;
                var display=8;
                var base=1;
              
                var half = Math.floor(display / 2.0);
                var total = Math.ceil(records / recordsperpage);
                var centered = 1;
                if (display % 2 != 0)
                  centered = 0;
      
                var cLft = true;
                var cRgt = true;
                var distance = 1;
                var remaining = display - 1;
                if (current > total + (base - 1)) {
                  current = total + (base - 1);
                }
                var pages = { previous: [], current: current, next: [], first: base, last: total + (base - 1) };
                while (cLft || cRgt) {
                  if (remaining > 0 && current - distance >= base) {
                    pages.previous.unshift(current - distance);
                    remaining--;
                  }
                  else {
                    cLft = false;
                  }
                  if (remaining > 0 && current + distance <= total + (base - 1)) {
                    pages.next.push(current + distance);
                    remaining--;
                  }
                  else {
                    cRgt = false;
                  }
                  distance++;
                }
                return pages;
              }                
          },
          view:function($event,item,source){
			$scope.retain(item);
			if (typeof(source)=='undefined'){
				var cell=$event.currentTarget.attributes.value;
				var item=item.item;
				if (cell.value=='cert'){
					$scope.onCert(item,$event);
				} else {
					var vx=item;
					var sc=$scope;
					window.onCertificate=function(){sc.onCert(vx,$event);}
					$scope.viewmodal=item;
					$scope.viewmodal.parent=$scope;
					window.setTimeout(function(){window.forceModal(null,null,$('#diamondview').html())},250);
				}
		   } else if(source=='viewmodal'){
				$scope.onCert($scope.viewmodal,$event);
				$scope.viewmodal=null;
		   }
          },
          viewcert:function(item){
			$scope.retain(item);  
			$scope.onCert(item,$event);
          },		  
          sort:function($event,item){
            var current=this.navigation.sort.split(' ');
            if (current.length==0) current=['','asc'];
            var cell=$event.currentTarget.attributes.value.value;
      
            if (cell==current[0]) {
              current[1]=(current[1]=='asc'?'desc':'asc');
            } else {
              current[0]=cell;
              current[1]='asc';
            }
            this.navigation.sort=current.join(' ');
            this.navigation.sorting.column=current[0];
            this.navigation.sorting.direction=current[1];
            this.change(false);
          },
		  onAdvanced:function(){this.advanced=!this.advanced;},
		  onSku:function(){
			this.change();
		  },
          onColor:function(color){
            var position=this.color.indexOf(color);
            if(position>=0){
              this.color.splice(position,1);
            } else {
              this.color.push(color);
            }
            $scope.filter.navigation.page=1;
            this.change();
          },
          hasColor:function(color){
            var position=this.color.indexOf(color);
            if(position>=0){
              return true;
            } else {
              return false;
            }
          },    
          
      onCut:function(cut){
            var position=this.cut.indexOf(cut);
            if(position>=0){
              this.cut.splice(position,1);
            } else {
              this.cut.push(cut);
            }
            $scope.filter.navigation.page=1;
            this.change();
          },
          hasCut:function(cut){
            var position=this.cut.indexOf(cut);
            if(position>=0){
              return true;
            } else {
              return false;
            }
          },    
      onClarity:function(clarity){
            var position=this.clarity.indexOf(clarity);
            if(position>=0){
              this.clarity.splice(position,1);
            } else {
              this.clarity.push(clarity);
            }
            $scope.filter.navigation.page=1;
            this.change();
          },
          hasClarity:function(clarity){
            var position=this.clarity.indexOf(clarity);
            if(position>=0){
              return true;
            } else {
              return false;
            }
          },      

      onPolish:function(polish){
            var position=this.polish.indexOf(polish);
            if(position>=0){
              this.polish.splice(position,1);
            } else {
              this.polish.push(polish);
            }
            $scope.filter.navigation.page=1;
            this.change();
          },
          hasPolish:function(polish){
            var position=this.polish.indexOf(polish);
            if(position>=0){
              return true;
            } else {
              return false;
            }
          },  	

      onSymmetry:function(symmetry){
            var position=this.symmetry.indexOf(symmetry);
            if(position>=0){
              this.symmetry.splice(position,1);
            } else {
              this.symmetry.push(symmetry);
            }
            $scope.filter.navigation.page=1;
            this.change();
          },
          hasSymmetry:function(symmetry){
            var position=this.symmetry.indexOf(symmetry);
            if(position>=0){
              return true;
            } else {
              return false;
            }
          },  		  
      onFluorescence:function(fluorescence){
            var position=this.fluorescence.indexOf(fluorescence);
            if(position>=0){
              this.fluorescence.splice(position,1);
            } else {
              this.fluorescence.push(fluorescence);
            }
            $scope.filter.navigation.page=1;
            this.change();
          },
          hasFluorescence:function(fluorescence){
            var position=this.fluorescence.indexOf(fluorescence);
            if(position>=0){
              return true;
            } else {
              return false;
            }
          },  		  
          onTable:function(min,max){
            this.table=[min,max];
            $scope.filter.navigation.page=1;
            this.change();
          },  
          onDepth:function(min,max){
            this.depth=[min,max];
            $scope.filter.navigation.page=1;
            this.change();
          },  		  
		  
          onShape:function(shape){
            this.shape=shape;
            this.ui(true);      
  		    //this.table=[shape.table[0]+'',shape.table[1]+''];
		    //this.depth=[shape.depth[0]+'',shape.depth[1]+''];
            $scope.filter.navigation.page=1;
            this.change();
          },
          hasShape:function(shape){
            return this.shape.name==shape.name;
          },
          onWeight:function(min,max){
            this.weight=[min,max];
            $scope.filter.navigation.page=1;
            this.change();
          },
          onPrice:function(min,max){
            this.price=[min,max];
            $scope.filter.navigation.page=1;
            this.change();
          },    
          assembleQuery:function(params){
            var result=[];
            for(var i=0;i<params.length;i++){
              var value="";
              if (params[i].field!='stocknumber' && params[i].value.length==2 && !isNaN(params[i].value[0])){
                value='['+params[i].value[0]+' TO '+params[i].value[1]+']';
              } else {
                switch(params[i].field){
				  case 'stocknumber':
					value='"'+params[i].value+'"';
				    break;
                  case 'item':
                    value=params[i].value.join('');
                    break;
                  default:
                    var vs=[];
                    for(var j=0;j<params[i].value.length;j++){
                      vs.push('"'+params[i].value[j]+'"');
                    }
                    value=vs.join(' OR ');              
                    break;
                }
              }
              result.push('('+params[i].field+':'+value+')');
            }
            return result.join(' AND ')+'AND%20NOT%20(%20stocknumber:"H")';
          },
          slider:function(slide,input,range,changecallback,reset){
             var target=angular.element(document.querySelector('#'+slide))[0];
             var changecallback=changecallback;
      
             var trange={};
             if (range[1]>50000){
              trange={
              'min': [range[0]],
              '30%': [range[0]+range[1]*0.0005],
              '60%': [range[0]+range[1]*0.001],
              '70%': [range[0]+range[1]*0.0015],
              '80%': [range[0]+range[1]*0.005],
              '90%': [range[0]+range[1]*0.1],
              'max': [range[1]]
                };
             } else {
              trange={
              'min': [range[0]],
              '30%': [range[0]+range[1]*0.01],
              '70%': [range[0]+range[1]*0.1],
              'max': [range[1]]
                };
             }
      
             if (!target.noUiSlider){
               var inputtarget_min=angular.element(document.querySelector('#'+input+'-min'))[0];
               var inputtarget_max=angular.element(document.querySelector('#'+input+'-max'))[0];
               if (range[1]>50000) {
                     noUiSlider.create(target,{range:{min:range[0],max:range[1]},start:range,connect:true,behaviour: 'tap-drag', range: trange});   
               target.noUiSlider.on('update',function(values,handle){
                 var fmt=function(x){ return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");}
                 
                 inputtarget_min.innerHTML = '$'+fmt(((values[0])*1).toFixed());
                 inputtarget_max.innerHTML = '$'+fmt(((values[1])*1).toFixed());
                 $scope.filter[changecallback](values[0],values[1]);
               });           
               } else {
          noUiSlider.create(target,{range:{min:range[0],max:range[1]},start:range,connect:true, behaviour: 'tap-drag',range: trange});                 
               target.noUiSlider.on('update',function(values,handle){
                 inputtarget_min.innerHTML = values[0];
                 inputtarget_max.innerHTML = values[1];
                 $scope.filter[changecallback](values[0],values[1]);
               });           
               }
             } else {
               var ops={
                  range: trange, behaviour: 'tap-drag'
               };
               if (typeof(reset)!='undefined' && reset){
                 ops.start=range;
               }
               target.noUiSlider.updateOptions(ops);
             }
          },
          ui:function(reset){
           this.slider('slider-weight','input-weight',this.shape.weight,'onWeight',reset);
           this.slider('slider-price','input-price',this.shape.price,'onPrice',reset);
		   this.slider('slider-depth','input-depth',this.shape.depth,'onDepth',reset);
		   this.slider('slider-table','input-table',this.shape.table,'onTable',reset);
          },
          changetimer:null,
          change:function(reset,instant){
            if (!instant){
              if(this.changetime) clearTimeout(this.changetime);
              this.changetime=window.setTimeout(function(){$scope.filter.handleChange(reset);},250);
            } else {
              this.handleChange(reset);
            }
          },
          
          handleChange:function(reset){
				if (!$scope.viewRetained) {
					$scope.loading=true;
					var url='https://www.since1910.com/services/hlgross.ashx?';
					var prms=[];
					var unq=Math.random()*1000000000;
					if(reset) { 
					   this.index=0;
					   $scope.filter.navigation.page=1;
					}
			  
					prms.push({'field':'item',value:['diamond']});
                    if (typeof(window.labgrown)!='undefined' && window.labgrown) {
                      prms.push({'field':'labgrown',value:['true']});
                    } else {
                      prms.push({'field':'labgrown',value:['false']});
                    }
					if (this.sku==null||this.sku.length==0){
						prms.push({'field':'shape',value:[this.shape.name]});
						if (this.color.length>0) prms.push({'field':'color',value:this.color});
						if (this.cut.length>0) prms.push({'field':'cut',value:this.cut});
						if (this.clarity.length>0) prms.push({'field':'clarity',value:this.clarity});
						if (this.polish.length>0) prms.push({'field':'polish',value:this.polish});
						if (this.symmetry.length>0) prms.push({'field':'symmetry',value:this.symmetry});
						if (this.fluorescence.length>0) prms.push({'field':'fluorescence',value:this.fluorescence});
						prms.push({'field':'weight',value:[this.weight[0],this.weight[1]]});
						prms.push({'field':'bprice',value:[this.price[0],this.price[1]]});
						prms.push({'field':'depth',value:[this.depth[0],this.depth[1]]});
						prms.push({'field':'table',value:[this.table[0],this.table[1]]});
					} else {
						prms.push({'field':'stocknumber',value:this.sku});
						$scope.filter.navigation.page=1;
					}
					var start = ($scope.filter.navigation.page-1)*$scope.filter.navigation.size;
				  url=url+'unq='+unq+'&start='+start+'&count='+this.navigation.size+'&sort='+this.navigation.sort+'&query='+this.assembleQuery(prms);
			  
					$http.get(url)
					  .then(function (response){
					  if(response.data.data) {
						$scope.results=response.data;
						$scope.selected=null;
						$scope.filter.navigation.index=$scope.results.index;
						$scope.filter.navigation.length=$scope.results.length;
						$scope.filter.navigation.start=$scope.filter.navigation.length>0?$scope.filter.navigation.index+1:0;
						$scope.filter.navigation.end=$scope.filter.navigation.index+$scope.results.data.length;
						
							$scope.filter.navigation.page=parseInt($scope.filter.navigation.index/$scope.filter.navigation.size)+1;
			  
						$scope.filter.navigation.sort=$scope.results.sort;
						  var srt=$scope.results.sort.split(' ');
						  $scope.filter.navigation.sorting.column=srt[0];
						$scope.filter.navigation.sorting.direction=srt[1];		  
						$scope.filter.navigation.pages=$scope.filter.navigation.init();          
						
						$scope.results.data.map(function(d){if (typeof(d.il)!='undefined' && d.il!=null && d.il.includes('3.227.185.194')) d.il=null; });
					  }
					  else {
						$scope.results=[];
						$scope.selected=null;
						$scope.filter.navigation.pages=$scope.filter.navigation.init();          
						$scope.filter.navigation.index=0;
						$scope.filter.navigation.end=0;
						$scope.filter.navigation.start=0;
						$scope.filter.navigation.page=1;
						$scope.filter.navigation.length=0;
					  }
					  $scope.loading=false;
					});
			  } else {
				  $scope.loading=true;
				  $scope.selected=null;
				  var n=null;
				  var desc=$scope.filter.navigation.sorting.direction=='desc';
				  switch($scope.filter.navigation.sorting.column){
					  case 'weight':n='c0';break;
					  case 'color':n='c1';break;
					  case 'clarity':n='c2';break;
					  case 'cut':n='c3';break;
					  case 'shape':n='shape';break;
					  case 'cert':n='lb';break;
					  case 'depth':n='d';break;
					  case 'table':n='t';break;
					  case 'price':n='price';break;
				  }
				  $scope.results.data.sort(function(a,b){
					  if(!isNaN(a[n])&&!isNaN(b[n])){
						  if(desc){
							  return (a[n]*1<b[n]*1)?1:-1;
						  } else {
							  return (a[n]*1>b[n]*1)?1:-1;
						  }
					  } else {
						  if(desc){
							  return (a[n]<b[n])?1:-1;
						  } else {
							  return (a[n]>b[n])?1:-1;
						  }
					  }
				  });
				  window.setTimeout(function(){
					$scope.loading=false;					  
					$scope.$apply();					  
				  },0);
			  }
			}
        };
        $scope.filter.ui();
        $scope.filter.change(true,true);
		var middlef=$scope;
		window.mfer=function(f2c,v2u){
			var $scope=middlef;
			middlef[f2c](v2u);
		};
      }

SNTController.$inject = ['$scope', 'Diamonds', '$http'];
        
window.onscroll=function(){ 
		try { 
			var v=window.scrollY-$('.affix-top').parent().offset().top+30; 
			var mx=$('#diamond-results').height();
			var h=$('.affix-top').height();
			if (v>0) {
				//console.log([v,mx,h,mx-h]);
				if (v>mx-h) v=mx-h;
				$('.affix-top').css({'margin-top':(v)+'px'}); 
			} else {
			$('.affix-top').css({'margin-top':'0px'}); 
			}
		} catch(ex){} 
	};
	  /*
window.orignalwidth=jQuery('.affix-top').width();
jQuery(document).on('scroll',function(){
	var y=window.scrollY;
	var h=jQuery('.affix-top').height();
	var t=jQuery('.affix-top').offset().top;
	var pt=jQuery('.affix-top').parent().offset().top;
	var ph=jQuery('.affix-top').closest('.row-flex').height();

	if (y>pt){
		if (y-ph+h>-50){
			jQuery('.affix-top').css({'position':'fixed',bottom:y-ph+h,width:window.orignalwidth+'px'});
		} else {
			jQuery('.affix-top').css({'position':'fixed',bottom:'unset',width:window.orignalwidth+'px'});	
		}
	}
});
   */